import { defineStore } from 'pinia';
import {ref, watch} from 'vue';
import { getUser } from '../services/auth'
import { Dialog } from 'quasar'
import { getFirestore, doc, setDoc } from 'firebase/firestore'
import api from '../services/api'
import extend from 'just-extend'
import { notify, roles } from '../utils/utils'
import { useTeamStore } from "stores/team";

export const useUserStore = defineStore('user', () => {
  /**
   * @type {Ref<User>}
   */
  const user = ref({})
  const collectingUserName = ref(false)
  const teamStore = useTeamStore()
  const permitted = ref({
      data: {
        VIEW: false,
        MANAGE: false,
      },
      forms: {
        DELETE: false,
        VIEW: false,
        EDIT: false,
        TRANSFER: false,
        CREATE: false,
      },
      team: {
        INVITE: false,
        EDIT: false,
      },
      workspace: {
        VIEW: false,
        MANAGE: false,
        DELETE: false,
      }
    })
  watch(() => teamStore.currentTeamMember,
    (teamMember) => {
      permitted.value = {
        data: {
          VIEW: roles.data[teamMember?.roles?.data]?.n >= roles.data.VIEW.n,
          MANAGE: roles.data[teamMember?.roles?.data]?.n >= roles.data.MANAGE.n
        },
        forms: {
          DELETE:  roles.forms[teamMember?.roles?.forms]?.n >= roles.forms.MANAGE.n,
          VIEW: roles.forms[teamMember?.roles?.forms]?.n >= roles.forms.MANAGE.n,
          EDIT: roles.forms[teamMember?.roles?.forms]?.n >= roles.forms.MANAGE.n,
          TRANSFER: roles.forms[teamMember?.roles?.forms]?.n >= roles.forms.MANAGE.n,
          CREATE: roles.forms[teamMember?.roles?.forms]?.n >= roles.forms.MANAGE.n,
        },
        team: {
          INVITE: roles.team[teamMember?.roles?.team]?.n >= roles.team.INVITE.n,
          EDIT: roles.team[teamMember?.roles?.team]?.n >= roles.team.MANAGE.n,
        },
        workspace: {
          VIEW: roles.workspace[teamMember?.roles?.workspace]?.n >= roles.workspace.VIEW.n,
          MANAGE: roles.workspace[teamMember?.roles?.workspace]?.n >= roles.workspace.MANAGE.n,
          DELETE: roles.workspace[teamMember?.roles?.workspace]?.n >= roles.workspace.ADMIN.n,
        }
      }
    },
    {immediate: true}
    )

  function $reset() {
    user.value = {}
    collectingUserName.value = false,
    permitted.value = {
        data: {
          VIEW: false,
          MANAGE: false,
        },
        forms: {
          DELETE: false,
          VIEW: false,
          EDIT: false,
          TRANSFER: false,
          CREATE: false,
        },
        team: {
          INVITE: false,
          EDIT: false,
        },
        workspace: {
          VIEW: false,
          MANAGE: false,
          DELETE: false,
        }
      }
  }

  async function loadUser (force) {
    if (user.value.id && !force) {
      return
    }
    const {uid, email, emailVerified} = await getUser()
    const myUser = await api.getMyUser()
    user.value = extend( {id:uid, email, emailVerified}, myUser)
    if (!user.value.name) {
      await setUserName()
    }
  }

  async function setUserName () {
    if (collectingUserName.value) {
      return
    }
    collectingUserName.value = true
    Dialog.create({
      title: 'Hi there, what should we call you?',
       message: 'We’d love to personalize your experience! Tell us your name so we can address you properly.',
      prompt: {
        model: '',
        isValid: val => val.trim().length >= 2 ,
        type: 'text',
      },
      cancel: false,
      persistent: true,
      ok: {
        label: 'Let\'s go',
        noCaps: true,
      }
    }).onOk(async data => {
      console.log('name dialog data', data)
      await notify(`Got it, ${data}, thanks!`, {})
      user.value.name = data
      // await loadUser()
      const db = getFirestore()
      await setDoc(doc(db, 'users', user.value.id), {
        name: data,
        email: user.value.email
      })
      collectingUserName.value = false
    })
  }

  return {
    $reset,
    user,
    loadUser,
    permitted
  }
})

/**
 * @typedef User
 * @property {string} id
 * @property {string} email
 * @property {boolean} emailVerified
 * @property {string} name
 */
